import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  HostListener,
  ViewChild,
  ElementRef
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';

export interface DropdownOption {
  id: string | number;
  text: string;
}

@Component({
  selector: 'canvas-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  imports: [FontAwesomeModule, ReactiveFormsModule, CommonModule, OverlayModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class DropdownComponent implements OnInit {
  @Input() options: DropdownOption[] = [];
  @Input() icon = faEllipsisVertical; 
  @Input() selectedId: string | number | null = null;
  @Input() hideSearch = false;

  @Output() optionSelected = new EventEmitter<DropdownOption | null>();

  searchControl = new FormControl('');
  filteredOptions: DropdownOption[] = [];
  dropdownOpen = false;
  faEllipsisVertical = faEllipsisVertical;

  @ViewChild('trigger', { static: false }) triggerRef!: ElementRef;

  constructor() {
    this.searchControl.valueChanges.subscribe((search) => {
      const term = (search ?? '').toLowerCase();
      this.filteredOptions = this.options.filter((o) =>
        o.text.toLowerCase().includes(term)
      );
    });
  }

  ngOnInit() {
    this.filteredOptions = this.options;
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
    if (this.dropdownOpen) {
      this.filteredOptions = this.options;
      this.searchControl.setValue('');
    }
  }

  selectOption(option: DropdownOption) {
    this.selectedId = option.id;
    this.optionSelected.emit(option);
    this.dropdownOpen = false;
  }

  clearSelection(event: MouseEvent) {
    event.stopPropagation();
    this.selectedId = null;
    this.optionSelected.emit(null);
    this.dropdownOpen = false;
  }

  getSelectedText(): string {
    const selectedOption = this.options.find((o) => o.id === this.selectedId);
    return selectedOption?.text ?? '';
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.dropdownOpen) {
      const target = event.target as HTMLElement;
      const trigger = this.triggerRef?.nativeElement;
      const dropdown = document.querySelector('.dropdown-wrapper');
      if (trigger && trigger.contains(target)) {
        return;
      }
      if (dropdown && dropdown.contains(target)) {
        return;
      }
      this.dropdownOpen = false;
    }
  }
}
